import React, { useContext, useEffect } from 'react';
import "./ExamRecommendationForm.css";
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserInfo } from '../../Context/UserInfoContext';
import { Packs } from '../../Context/PacksContext';
import { faAngleDown, faArrowRightLong } from "@fortawesome/free-solid-svg-icons";
import {MedicalContext} from '../../Context/MedicalContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import TinyTrashcanIcon from "../../../Photos/TinyTrashcanIcon.png"
import TinyExamIcon from "../../../Photos/TinyExamIcon.png"
import TinyPageIcon from "../../../Photos/TinyPageIcon.png"
import TinyEyeIcon from "../../../Photos/TinyEyeIcon.png"
import TinyClosedEyeIcon from "../../../Photos/TinyClosedEyeIcon.png"

import packslist from "../../../../JSONS/updatedPacks.json"
import packsSponsored from "../../../../JSONS/sponsoredPack.json"
import packsPhysical from "../../../../JSONS/physicalPacks.json"
import examslist from "../../../../JSONS/updatedExams.json"
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

function ExamRecommendationForm() {

  const Navigate = useNavigate();

  const MySwal = withReactContent(Swal)

  const formatter = new Intl.NumberFormat('es-CL', {
    style: 'currency',
    currency: 'CLP',
  });

  // Helper function to get pack info from any source (updatedPacks, sponsoredPack, or physicalPacks)
  const getPackInfo = (packKey) => {
    if (packslist[packKey]) return packslist[packKey];
    if (packsSponsored[packKey]) return packsSponsored[packKey];
    if (packsPhysical[packKey]) return packsPhysical[packKey];
    return null;
  }

  const {
     RelatedExams, SetRelatedExams
  } = useContext(MedicalContext);

  const {
    Phone, setPhone
  } = useContext(UserInfo);

  const {
    BasketPacks, SetBasketPacks, ExamsPerProduct, SetExamsPerProduct, SetAdded, 
  
  } = useContext(Packs);

  const [CurrentExamsForOrder,setCurrentExamsForOrder] = useState([])
  //const Recom = RelatedExams.length === 0 & UnrelatedExams.length === 0 ? 0 : RelatedExams.length !== 0 & UnrelatedExams.length !== 0 ? 2 : 1

  const [ExamDetails, setExamDetails] = useState(false);
  const [OpenBlock, setOpenBlock] = useState(-1);
  const [shown, setShown] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  var pages = Math.ceil(CurrentExamsForOrder.length / 3)
  const [numberOfBlocks, setNumberOfBlocks] = useState(0);
  const [examsShown, setExamsShown] = useState(Array.from([0, 1, 2]));
  const [packOne, setPackOne] = useState([]);
  const [packOneDer, setPackOneDer] = useState([]);
  const [OneTime, setOneTime] = useState(true);
  
  const [RecalcFonasa, setRecalcFonasa] = useState(false);

  const communeRM = ["Calera De Tango","Cerrillos","Cerro Navia","Colina","Conchali","El Bosque","El Monte","Estación Central","Huechuraba","Independencia","Isla De Maipo","La Cisterna","La Florida","La Granja","La Pintana","La Reina","Las Condes","Lo Barnechea","Lo Prado","Maipú","Macul","Ñuñoa","Padre Hurtado","Pedro Aguirre Cerda","Peñaflor","Peñalolén","Pirque","Providencia","Pudahuel","Puente Alto","Quilicura","Quinta Normal","Recoleta","Renca","San Bernardo","San Joaquií","San José de Miapo","San Miguel","San Ramón","Santiago","Talagante","Vitacura"]
  const communeAN = ["Antofagasta"]
  const communeCO = ["Coquimbo","La Serena"]
  const communeVA = ["Concón","Limache","Placilla","Quillota","Quilpué"]
  const communeBI = ["Chiguayante","Concepción","Coronel","Hualpén","Hualqui","Penco","San Pedro de la Paz","Talcahuano","Tomé"]

  useEffect(() => {
    if(document.getElementById('FullForm') && OneTime) {
     
      CalculateFonasa()
      setOneTime(false)
    }
    if(RecalcFonasa) {
      CalculateFonasa()
      setRecalcFonasa(false)
    }
  })

  useEffect(() => {
    if(numberOfBlocks !== BasketPacks.length & OpenBlock !== -1) {
      setExamDetails(false)
      let tmp6 = document.getElementsByClassName("ExamRecommendationFormInnerBoxLowerLines")
      let tmp7 = document.getElementsByClassName("ExamRecommendationFormInnerBoxLowerLinesPageDots")
      //let tmp8 = document.getElementsByClassName("ExamRecommendationFormInnerBoxRiskLines")
      for(let i=0;i<tmp6.length;i++) {
        if(!tmp6[i].classList.contains("ExamRecommendationFormHidden")) {
          tmp6[i].className += " ExamRecommendationFormHidden"
          tmp7[i].className += " ExamRecommendationFormHidden"
          //tmp8[i].className += " ExamRecommendationFormHidden"
        }
      }
      setCurrentPage(1)
      if(OpenBlock <= BasketPacks.length) {
        let tmp4 = document.getElementById('pageDot'.concat(currentPage))
        tmp4.className = tmp4.className.replace(" ActiveDot", "");
        let tmp5 = document.getElementById('pageDot1')
        tmp5.className += " ActiveDot"
      }
      setRecalcFonasa(true)
    }
  })

  function CalculateFonasa() {
    let exams = []
    for (const property in ExamsPerProduct) {
      exams.push(...ExamsPerProduct[property]['exams']);
    }
    exams.push(...RelatedExams)
    let uniques = [...new Set(exams)]

    let totalexams = uniques.length
    let accounted = 0
    let fonprice = 0
    for(let i=0;i<uniques.length;i++) {
      // Check if exam exists in examslist before accessing it
      if(examslist[exams[i]] && examslist[exams[i]].fonasa) {
        fonprice += examslist[exams[i]].fonasa
        accounted += 1
      }
    }
  }

  function ChangeExamPage(step, length) {
    let tmp = document.getElementById('pageDot'.concat(currentPage))
    //console.log(tmp,currentPage)
    tmp.className = tmp.className.replace(" ActiveDot", "");
    let tmp2 = document.getElementById('pageDot'.concat(currentPage + (step/3)))
    //console.log(tmp2,currentPage + (step/3))
    tmp2.className += " ActiveDot"

    setCurrentPage(currentPage + (step/3))
    //console.log(shown,length)
    if(shown === length - 1 & step > 0) {
      setExamsShown(Array.from([0], (x) => x + shown + step))
    } else if (shown == length - 2 & step > 0) {
      setExamsShown(Array.from([0, 1], (x) => x + shown + step))
    } else setExamsShown(Array.from([0, 1, 2], (x) => x + shown + step))
    setShown(shown + step)

    //console.log(shown,examsShown,currentPage)
  }

  function ShowDetails(block,id1,id3,exams) {
    //console.log(block,OpenBlock,ExamsPerProduct[BasketPacks[block-1]].exams.map(a => examslist[a]),exams)
    if(exams.length === 2) {
      setExamsShown(Array.from([0, 1]))
    } else if(exams.length === 1){
      setExamsShown(Array.from([0]))
    } else {
      setExamsShown(Array.from([0, 1, 2]))
    }
    let tmp = document.getElementById(id1)
    let tmp3 = document.getElementById(id3)
    let tmp6 = document.getElementsByClassName("ExamRecommendationFormInnerBoxLowerLines")
    let tmp7 = document.getElementsByClassName("ExamRecommendationFormInnerBoxLowerLinesPageDots")
    if(ExamDetails & block === OpenBlock) {
      setExamDetails(false)
      if(tmp) tmp.className += " ExamRecommendationFormHidden"
      if(tmp3) tmp3.className += " ExamRecommendationFormHidden"
      let tmp4 = document.getElementById('pageDot'.concat(currentPage))
      if(tmp4) tmp4.className = tmp4.className.replace(" ActiveDot", "");
      setCurrentPage(1)
      let tmp5 = document.getElementById('pageDot1')
      if(tmp5) tmp5.className += " ActiveDot"

    } else {
      setExamDetails(true)
      for(let i=0;i<tmp6.length;i++) {
        if(!tmp6[i].classList.contains("ExamRecommendationFormHidden")) {
          if(tmp6[i]) tmp6[i].className += " ExamRecommendationFormHidden"
          if(tmp7[i]) tmp7[i].className += " ExamRecommendationFormHidden"
        }
      }
      setNumberOfBlocks(BasketPacks.length)
      if(block !== 0) {
        // Filter and map exams, only including those that exist in examslist
        setPackOne(ExamsPerProduct[BasketPacks[block-1]].exams.filter(b => examslist[b] && examslist[b].emission !== "Derivaciones" && examslist[b].emission !== "").map(a => examslist[a]))
        setPackOneDer(ExamsPerProduct[BasketPacks[block-1]].exams.filter(b => examslist[b] && examslist[b].emission === "Derivaciones").map(a => examslist[a]))
      } else {
        setPackOne(RelatedExams.filter(b => examslist[b] && examslist[b].emission !== "Derivaciones" && examslist[b].emission !== "").map(a => examslist[a]))
        setPackOneDer(RelatedExams.filter(b => examslist[b] && examslist[b].emission === "Derivaciones").map(a => examslist[a]))
      }
      setOpenBlock(block)
      tmp.className = tmp.className.replace(" ExamRecommendationFormHidden", "");
      if(tmp3) tmp3.className = tmp3.className.replace(" ExamRecommendationFormHidden", "");
      setCurrentPage(1)
      setShown(0)
    }
  }

  function EliminateBlock(pack) {
    if(pack === "Recommended") {
      SetRelatedExams([])
    } else {
      let listOfPacks = BasketPacks
      let examsOfPacks = ExamsPerProduct
      let index = listOfPacks.indexOf(pack);
      if (index > -1) { 
          listOfPacks.splice(index, 1); 
      }
      delete examsOfPacks[pack]
      SetBasketPacks([...listOfPacks])
      SetExamsPerProduct({...examsOfPacks})
      SetAdded(false)
      setRecalcFonasa(true)
    }
  }

  

  return (
    <>
    {RelatedExams.length === 0 & BasketPacks.length === 0 ?
    <div className="ExamRecommendationFormDivEmpty">
      <div className="ExamRecommendationFormEmpty">Tu Orden Médica está vacía</div>
      <div className="ExamRecommendationFormEmptyInfo">Puedes revisar nuestros exámenes disponibles aquí:</div>
      <div className="ExamRecommendationFormEmptyButton" onClick={() => Navigate("/packs-de-examenes")}>Ver Exámenes</div>
      
    </div>
    :
    <div className="ExamRecommendationFormDiv" id="FullForm">
      <div className="ExamRecommendationFormInnerDiv1">
        <div className="ExamRecommendationFormUpperTitleFlex">
          <div className="ExamRecommendationFormUpperTitleText">Producto</div>
          <div className='ExamRecommendationFormUpperTitleRightSide'>Precio</div>
        </div>
      <div className="ExamRecommendationFormDiv">
        {RelatedExams.length === 0 ?
        null
        :
        <div>
        <div className="ExamRecommendationFormInnerBox">
          <div className="ExamRecommendationFormInnerBoxUpperRow">
            <div className="ExamRecommendationFormInnerBoxUpperRowText">Exámenes Recomendados</div>
        {/*    <div className="ExamRecommendationFormInnerBoxUpperRowIcons">
              <img className="ExamRecommendationFormInnerBoxUpperRowExamIcon" alt='' src={TinyExamIcon} />
              <img className="ExamRecommendationFormInnerBoxUpperRowPageIcon" alt='' src={TinyPageIcon} />
            </div> */}
            <div className="ExamRecommendationFormInnerBoxUpperRowRightSide">
              {ExamDetails & OpenBlock === 0 ? 
              <div className="ExamRecommendationFormInnerBoxShowDetails" onClick={() => ShowDetails(0,"PackDetails".concat(0),"PackDots".concat(0),RelatedExams.filter(obj => examslist[obj] && examslist[obj].emission !== "Derivaciones" && examslist[obj].emission !== ""))}>
                <div className="ExamRecommendationFormInnerBoxShowDetailsText">Ocultar Detalle</div>
                <img className="ExamRecommendationFormInnerBoxEyeIcon" alt='' src={TinyEyeIcon} />
              </div>
              :
              <div className="ExamRecommendationFormInnerBoxShowDetails" onClick={() => ShowDetails(0,"PackDetails".concat(0),"PackDots".concat(0),RelatedExams.filter(obj => examslist[obj] && examslist[obj].emission !== "Derivaciones" && examslist[obj].emission !== ""))}>
                <div className="ExamRecommendationFormInnerBoxShowDetailsText">Mostrar Detalle</div>
                <img className="ExamRecommendationFormInnerBoxEyeIcon" alt='' src={TinyClosedEyeIcon} />
              </div> }
              <div className="ExamRecommendationFormInnerBoxUpperRowPackPrice">$ 990</div>
              <img className="ExamRecommendationFormInnerBoxUpperRowTrashcanIcon" alt='' src={TinyTrashcanIcon} 
              onClick={() => MySwal.fire({
                title: "Desea eliminar el pack de su Orden Médica?",
                showDenyButton: false,
                showCancelButton: true,
                confirmButtonText: "Eliminar",
                confirmButtonColor: "#6633FF"
                }).then((result) => {
                  /* Read more about isConfirmed, isDenied below */
                  if (result.isConfirmed) {
                    EliminateBlock("Recommended")
                    MySwal.fire({
                      icon: "success",
                      iconColor: "#6633FF",
                      title: "El pack fue eliminado con éxito",
                      showConfirmButton: false,
                      timer: 1500
                    })
                  }
                })}/>
            </div>
            
          </div>


          <div className="ExamRecommendationFormInnerBoxHorizontalLine"></div>


          <div className="ExamRecommendationFormInnerBoxLowerLines ExamRecommendationFormHidden" id={"PackDetails".concat(0)}>
          {packOne.length === 0 ?
            null :
            <>
            <div className="ExamRecommendationFormInnerBoxLowerLinesFlex">
              <div className="ExamRecommendationFormInnerBoxLowerLinesLeftFlex">
                <img className="ExamRecommendationFormInnerBoxUpperRowExamIcon" alt='' src={TinyExamIcon} />
                <img className="ExamRecommendationFormInnerBoxUpperRowPageIcon" alt='' src={TinyPageIcon} />
                <div className="ExamRecommendationFormInnerBoxLowerLinesLeftText">Exámenes:</div>
              </div>
              {/* <div>({ExamsPerProduct[BasketPacks[IndividualPack]].exams.length})</div> */}
            </div>
            <div className="ExamRecommendationFormInnerBoxExamLinesFlex">
              {shown === 0 ?
              null
              :
              <div className="ExamRecommendationFormInnerBoxExamLineArrowBlock" onClick={() => ChangeExamPage(-3,packOne.length-3)}>
                <FontAwesomeIcon 
                  icon={faArrowRightLong} 
                  className='ExamRecommendationFormInnerBoxExamLineLeftArrow text-end fa-rotate-180'
                />
              </div>
  }
              <div className="ExamRecommendationFormInnerBoxExamLineExamBlockContainer">
              {examsShown.map((exam) => (
              
                <div className="ExamRecommendationFormInnerBoxExamLineExamBlock" key={exam}>
                  {OpenBlock === 0 ? 
                  <div className="ExamRecommendationFormInnerBoxExamLineExamNameFlex">
                    <img className="ExamRecommendationFormInnerBoxExamLineExamIcon" alt='' src={TinyExamIcon} />
                    <div className="ExamRecommendationFormInnerBoxExamLineExamName">{packOne[exam].name}</div>
                  </div>
                  : null}
                  {packOne[exam] ?
                  <div className="ExamRecommendationFormInnerBoxExamLineExamDescription">{packOne[exam].description}</div>
                  : null }
                </div>
              
              ))}
              </div>
              {shown >= packOne.length-3 ?
              null:
              <div className="ExamRecommendationFormInnerBoxExamLineArrowBlock" onClick={() => ChangeExamPage(3,packOne.length-3)}>
                <FontAwesomeIcon 
                  icon={faArrowRightLong} 
                  className='ExamRecommendationFormInnerBoxExamLineRightArrow text-end'
                />
              </div>
  }
            </div>
            <div className="ExamRecommendationFormInnerBoxLowerLinesPageDots" id={"PackDots".concat(0)}>
            {OpenBlock === 0 ?
            <>
              <div className="ExamRecommendationFormInnerBoxLowerLinesIndividualPageDot ActiveDot" id="pageDot1"></div>
              {[...Array(Math.ceil(packOne.length / 3)-1).keys()].map((dots) => (
              <div className="ExamRecommendationFormInnerBoxLowerLinesIndividualPageDot" key={'pageDot'.concat(dots+2)} id={'pageDot'.concat(dots+2)}></div>
              ))}
              </>
              : null}
              
            </div>
            </>
            }
            {packOneDer.length === 0 ?
            null :
            <>
            <div className="ExamRecommendationFormInnerBoxLowerLinesFlex">
              <div className="ExamRecommendationFormInnerBoxLowerLinesLeftFlex">
                <img className="ExamRecommendationFormInnerBoxUpperRowExamIcon" alt='' src={TinyExamIcon} />
                <img className="ExamRecommendationFormInnerBoxUpperRowPageIcon" alt='' src={TinyPageIcon} />
                <div className="ExamRecommendationFormInnerBoxLowerLinesLeftText">Derivaciones:</div>
              </div>
            </div>
            <div className="ExamRecommendationFormInnerBoxRiskLines">

              {packOneDer.map((exam) => (
              
              <div className="ExamRecommendationFormInnerBoxExamLineExamBlock" key={exam}>
                <div className="ExamRecommendationFormInnerBoxExamLineExamNameFlex">
                  <img className="ExamRecommendationFormInnerBoxExamLineExamIcon" alt='' src={TinyExamIcon} />
                  <div className="ExamRecommendationFormInnerBoxExamLineExamName">{exam.name}</div>
                </div>
              </div>
            
            ))}

            </div>
            </>
              }
          </div>
        </div>
        </div>
  }
      </div>



      {[...Array(BasketPacks.length).keys()].map((IndividualPack) => (
        <div key={IndividualPack}>
        <div className="ExamRecommendationFormInnerBox">
          <div className="ExamRecommendationFormInnerBoxUpperRow">
            <div className="ExamRecommendationFormInnerBoxUpperRowText">{getPackInfo(BasketPacks[IndividualPack])?.name || "Pack"}</div>
        {/*    <div className="ExamRecommendationFormInnerBoxUpperRowIcons">
              <img className="ExamRecommendationFormInnerBoxUpperRowExamIcon" alt='' src={TinyExamIcon} />
              <img className="ExamRecommendationFormInnerBoxUpperRowPageIcon" alt='' src={TinyPageIcon} />
            </div> */}
            <div className="ExamRecommendationFormInnerBoxUpperRowRightSide">
              {ExamDetails & OpenBlock === IndividualPack+1 ? 
              <div className="ExamRecommendationFormInnerBoxShowDetails" onClick={() => ShowDetails(IndividualPack+1,"PackDetails".concat(IndividualPack+1),"PackDots".concat(IndividualPack),ExamsPerProduct[BasketPacks[IndividualPack]].exams.filter(obj => examslist[obj] && examslist[obj].emission !== "Derivaciones" && examslist[obj].emission !== ""))}>
                <div className="ExamRecommendationFormInnerBoxShowDetailsText">Ocultar Detalle</div>
                <img className="ExamRecommendationFormInnerBoxEyeIcon" alt='' src={TinyEyeIcon} />
              </div>
              :
              <div className="ExamRecommendationFormInnerBoxShowDetails" onClick={() => ShowDetails(IndividualPack+1,"PackDetails".concat(IndividualPack+1),"PackDots".concat(IndividualPack),ExamsPerProduct[BasketPacks[IndividualPack]].exams.filter(obj => examslist[obj] && examslist[obj].emission !== "Derivaciones" && examslist[obj].emission !== ""))}>
                <div className="ExamRecommendationFormInnerBoxShowDetailsText">Mostrar Detalle</div>
                <img className="ExamRecommendationFormInnerBoxEyeIcon" alt='' src={TinyClosedEyeIcon} />
              </div> }
              {ExamsPerProduct[BasketPacks[IndividualPack]].price === 0 ?
              <div className="ExamRecommendationFormInnerBoxUpperRowPackPrice">Gratis</div>
              :
              <div className="ExamRecommendationFormInnerBoxUpperRowPackPrice">{formatter.format(ExamsPerProduct[BasketPacks[IndividualPack]].price)}</div>
  }
              <img className="ExamRecommendationFormInnerBoxUpperRowTrashcanIcon" alt='' src={TinyTrashcanIcon} 
              onClick={() => MySwal.fire({
                title: "Desea eliminar el pack de su Orden Médica?",
                showDenyButton: false,
                showCancelButton: true,
                confirmButtonText: "Eliminar",
                confirmButtonColor: "#6633FF"
                }).then((result) => {
                  /* Read more about isConfirmed, isDenied below */
                  if (result.isConfirmed) {
                    EliminateBlock(BasketPacks[IndividualPack])
                    MySwal.fire({
                      icon: "success",
                      iconColor: "#6633FF",
                      title: "El pack fue eliminado con éxito",
                      showConfirmButton: false,
                      timer: 1500
                    })
                  }
                })}/>
            </div>
            
          </div>
          <div className="ExamRecommendationFormInnerBoxHorizontalLine"></div>
          <div className="ExamRecommendationFormInnerBoxLowerLines ExamRecommendationFormHidden" id={"PackDetails".concat(IndividualPack+1)}>
            {packOne.length === 0 ?
            null :
            <>
            <div className="ExamRecommendationFormInnerBoxLowerLinesFlex">
              <div className="ExamRecommendationFormInnerBoxLowerLinesLeftFlex">
                <img className="ExamRecommendationFormInnerBoxUpperRowExamIcon" alt='' src={TinyExamIcon} />
                <img className="ExamRecommendationFormInnerBoxUpperRowPageIcon" alt='' src={TinyPageIcon} />
                <div className="ExamRecommendationFormInnerBoxLowerLinesLeftText">Exámenes:</div>
              </div>
              {/* <div>({ExamsPerProduct[BasketPacks[IndividualPack]].exams.length})</div> */}
            </div>
            <div className="ExamRecommendationFormInnerBoxExamLinesFlex">
              {shown === 0 ?
              null
              :
              <div className="ExamRecommendationFormInnerBoxExamLineArrowBlock" onClick={() => ChangeExamPage(-3,packOne.length-3)}>
                <FontAwesomeIcon 
                  icon={faArrowRightLong} 
                  className='ExamRecommendationFormInnerBoxExamLineLeftArrow text-end fa-rotate-180'
                />
              </div>
  }
              <div className="ExamRecommendationFormInnerBoxExamLineExamBlockContainer">
              {examsShown.map((exam) => (
              
                <div className="ExamRecommendationFormInnerBoxExamLineExamBlock" key={exam}>
                  {OpenBlock === IndividualPack+1 ? 
                  <div className="ExamRecommendationFormInnerBoxExamLineExamNameFlex">
                    <img className="ExamRecommendationFormInnerBoxExamLineExamIcon" alt='' src={TinyExamIcon} />
                    <div className="ExamRecommendationFormInnerBoxExamLineExamName">{packOne[exam].name}</div>
                  </div>
                  : null}
                  {packOne[exam] ?
                  <div className="ExamRecommendationFormInnerBoxExamLineExamDescription">{packOne[exam].description}</div>
                  : null }
                </div>
              
              ))}
              </div>
              {shown >= packOne.length-3 ?
              null:
              <div className="ExamRecommendationFormInnerBoxExamLineArrowBlock" onClick={() => ChangeExamPage(3,packOne.length-3)}>
                <FontAwesomeIcon 
                  icon={faArrowRightLong} 
                  className='ExamRecommendationFormInnerBoxExamLineRightArrow text-end'
                />
              </div>
  }
            </div>
            <div className="ExamRecommendationFormInnerBoxLowerLinesPageDots" id={"PackDots".concat(IndividualPack)}>
            {OpenBlock === IndividualPack+1 ?
            <>
              <div className="ExamRecommendationFormInnerBoxLowerLinesIndividualPageDot ActiveDot" id="pageDot1"></div>
              {[...Array(Math.ceil(packOne.length / 3)-1).keys()].map((dots) => (
              <div className="ExamRecommendationFormInnerBoxLowerLinesIndividualPageDot" key={'pageDot'.concat(dots+2)} id={'pageDot'.concat(dots+2)}></div>
              ))}
              </>
              : null}
              
            </div>
            </>
            }
            {packOneDer.length === 0 ?
            null :
            <>
            <div className="ExamRecommendationFormInnerBoxLowerLinesFlex">
              <div className="ExamRecommendationFormInnerBoxLowerLinesLeftFlex">
                <img className="ExamRecommendationFormInnerBoxUpperRowExamIcon" alt='' src={TinyExamIcon} />
                <img className="ExamRecommendationFormInnerBoxUpperRowPageIcon" alt='' src={TinyPageIcon} />
                <div className="ExamRecommendationFormInnerBoxLowerLinesLeftText">Derivaciones:</div>
              </div>
            </div>
            <div className="ExamRecommendationFormInnerBoxRiskLines">

              {packOneDer.map((exam) => (
              
              <div className="ExamRecommendationFormInnerBoxExamLineExamBlock" key={exam}>
                <div className="ExamRecommendationFormInnerBoxExamLineExamNameFlex">
                  <img className="ExamRecommendationFormInnerBoxExamLineExamIcon" alt='' src={TinyExamIcon} />
                  <div className="ExamRecommendationFormInnerBoxExamLineExamName">{exam.name}</div>
                </div>
              </div>
            
            ))}

            </div>
            </>
              }
          </div>
        </div>
      </div>
  ))}
          </div>
   
          </div>
        }
    </>
  );
}

export default ExamRecommendationForm